
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconChartBarStackedSelector = "fhi-icon-chart-bar-stacked";

/**
 * ## FhiIconChartBarStacked
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-chart-bar-stacked
 * @element fhi-icon-chart-bar-stacked
 */
@customElement(FhiIconChartBarStackedSelector)
export class FhiIconChartBarStacked extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M3 2.25a.75.75 0 0 1 .75.75v16A1.25 1.25 0 0 0 5 20.25h16a.75.75 0 0 1 0 1.5H5A2.75 2.75 0 0 1 2.25 19V3A.75.75 0 0 1 3 2.25m12 10c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 15 17.75H8A1.75 1.75 0 0 1 6.25 16v-2c0-.966.784-1.75 1.75-1.75zm-7 1.5a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h2.25v-2.5zm3.75 2.5H15a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25h-3.25zm6.25-12c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 18 9.75H8A1.75 1.75 0 0 1 6.25 8V6c0-.966.784-1.75 1.75-1.75zm-2.25 4H18a.25.25 0 0 0 .25-.25V6a.25.25 0 0 0-.25-.25h-2.25zM8 5.75a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h6.25v-2.5z"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
